import React from 'react'
import { FieldError, FieldErrors, UseFormRegister } from 'react-hook-form'
import { AppraisalFormProps } from '../../Interface/EmployeeManager/AppraisalForm/AppraisalForm'

interface ApTextareaProps {
  name: string
  index: number
  register: UseFormRegister<any> // Replace `any` with your form's data type
  errors?: FieldErrors<AppraisalFormProps>
  rules?: object
  disabled: boolean
}

const ApTextarea: React.FC<ApTextareaProps> = ({
  name,
  index,
  register,
  errors,
  rules,
  disabled,
}) => {
  return (
    <div className='form-group'>
      <textarea
        id={name}
        {...register(name, rules)}
        className={`form-control ${
          errors && errors.personalAssessment && errors.personalAssessment[index]?.answer
            ? 'is-invalid'
            : ''
        }`}
        disabled={disabled}
        // placeholder={`Enter ${label.toLowerCase()}`}
      ></textarea>
      {errors && errors.personalAssessment && (
        <div className='invalid-feedback'>{errors.personalAssessment[index]?.answer?.message}</div>
      )}
    </div>
  )
}

export default ApTextarea
